import { useRef } from "react";
import Konva from "konva";
import { Group, Rect, Text } from "react-konva";
import { KonvaTooltip } from "frontend/ui-components/design-system/tooltip/konva-tooltip";
import { Tag } from "shared/datamodel/schemas/metadata";
import { TAG_HEIGHT, TAG_PADDING } from "../../consts";

export function TaskTag({
  tag,
  tagX,
  tagWidth,
  textWidth,
  isTruncated,
}: {
  tag: Tag;
  tagX: number;
  tagWidth: number;
  textWidth: number;
  isTruncated: boolean;
}) {
  const tooltipNode = useRef<Konva.Rect | null>(null);

  return (
    <>
      <Group>
        <Rect x={tagX} width={tagWidth} height={TAG_HEIGHT} fill={tag.color} cornerRadius={6} ref={tooltipNode} />
        <Text
          x={tagX + TAG_PADDING}
          y={1}
          text={tag.name}
          fontSize={12}
          fill="#FFF"
          fontWeight={400}
          fontFamily="Poppins"
          letterSpacing={0.124}
          width={textWidth}
          height={TAG_HEIGHT}
          align="center"
          verticalAlign="middle"
          ellipsis={true}
          wrap="none"
          listening={false}
        />
      </Group>
      <KonvaTooltip text={tag.name} nodeRef={tooltipNode} maxWidth={450} offset={8} disabled={!isTruncated} />
    </>
  );
}
